import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { RowIcon } from '@/common/entityFramework/entityPerspective/support/RowIcon';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useRef } from 'react';

export const AbvSapActualsPerspective = () => {
  const entityPerspectiveRef = useRef();

  const views = [
    {
      name: 'Balances',
      dims: ['PAID_PERIOD', 'CHANNEL', 'COMPANY_CODE'],
      kpis: ['START_BAL', 'AUTO_ACCR_AMT', 'MAN_ACCR_AMT', 'PIPE_AMT', 'TOTAL_ACCR', 'TOTAL_PYMT', 'END_BAL'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['YEAR', 'QTR', 'MON'],
      },
    },
    {
      name: 'Accruals',
      dims: ['PAID_PERIOD', 'CHANNEL', 'COMPANY_CODE', 'PROD', 'EARNED_PERIOD'],
      kpis: ['AUTO_ACCR_AMT', 'MAN_ACCR_AMT', 'PIPE_AMT', 'TOTAL_ACCR'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
    {
      name: 'Payments',
      dims: ['PAID_PERIOD', 'CHANNEL', 'COMPANY_CODE', 'PROD', 'EARNED_PERIOD'],
      kpis: ['AUTO_PYMT_AMT', 'MAN_PYMT_AMT', 'TOTAL_PYMT'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
  ];

  const rowIconsFn = (data) => {
    let rowIcons = [];

    if (data.closed) {
      rowIcons.push(<RowIcon key="closed" icon={fas.faCheckCircle} color="green" toolTip="Period is closed" />);
    }

    return rowIcons;
  };

  // TODO: Only show the accrual and payment items depending on the view
  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    const accrItems = [
      {
        name: 'Auto Accruals',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'AUTO_ACCR_AMT', 'Auto Accruals'),
        icon: fas.faListUl,
      },
      {
        name: 'Manual Accruals',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'MAN_ACCR_AMT', 'Manual Accruals'),
        icon: fas.faListUl,
      },
      {
        name: 'Pipeline Adjustments',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PIPE_AMT', 'Pipeline Adjustments'),
        icon: fas.faListUl,
      },
    ];

    const pymtItems = [
      {
        name: 'Payments From Auto Accounts',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(params, 'AUTO_PYMT_AMT', 'Payments From Auto Accounts'),
        icon: fas.faListUl,
      },
      {
        name: 'Payments From Manual Accounts',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(params, 'MAN_PYMT_AMT', 'Payments From Manual Accounts'),
        icon: fas.faListUl,
      },
    ];

    contextMenus.push(
      {
        name: 'Start Balances',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'START_BAL', 'Start Balances'),
        icon: fas.faListUl,
      },
      {
        name: 'Accrual Transaction Details',
        subMenu: accrItems,
        icon: fas.faListUl,
      },
      {
        name: 'Payment Transaction Details',
        subMenu: pymtItems,
        icon: fas.faListUl,
      },
      {
        name: 'Export',
        action: () => entityPerspectiveRef.current.openExportDialog(params),
        icon: fas.faArrowCircleDown,
      },
    );

    return contextMenus;
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      rowIconsFn={rowIconsFn}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
